import React from 'react';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { computersGenitive } from 'reactApp/utils/pluralHelpers';

import styles from './MultiSessionFeaturesList.css';

interface Feature {
    text: string;
    hideWhenProductWithAds?: boolean;
}

const featuresList: Feature[] = [
    { text: '1 ТБ для писем и файлов' },
    { text: 'Без рекламы в Почте и Облаке', hideWhenProductWithAds: true },
    { text: 'Красивый адрес почты' },
    { text: 'Нейропомощник в\u00A0Почте' },
    { text: 'Краткий пересказ писем' },
    { text: 'Отправка вложений до\u00A0100\u00A0ГБ\u00A0в\u00A0письмах' },
    { text: 'Отмена отправки писем в\u00A0течение 30\u00A0секунд' },
];

export const MultiSessionFeaturesList = ({ deviceCount, productWithAds }: { deviceCount: number; productWithAds: boolean }) => {
    const list = [
        `Вход в\u00A0аккаунт ${USER_EMAIL} с\u00A0${deviceCount}\u00A0${computersGenitive(deviceCount)} `,
        ...featuresList.filter((feature) => !(productWithAds && feature.hideWhenProductWithAds)).map((feature) => feature.text),
    ];
    return (
        <div className={styles.root}>
            {list.map((feature, index) => (
                <li key={`${index}-${feature}`} className={styles.item}>
                    {feature}
                </li>
            ))}
        </div>
    );
};
